var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showModal)?_c('div',{staticStyle:{"font-size":"14px","margin-right":"10px"}},[_vm._v(" "+_vm._s(_vm.local.city)+" "+_vm._s(_vm.local.text)+" "+_vm._s(_vm.local.temperature)+"℃ ")]):_vm._e(),(!_vm.showModal)?_c('div',[_vm._v(_vm._s(_vm.local.temperature)+"℃")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }